import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import TimesheetCategoryDropdown from "pages/TimeSheetManage/Dropdowns/TimesheetCategoryDropdown";
import { map } from "lodash";
import Select from "react-select";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // No dropdown, so no show state needed
  const [categoryValue, setCategoryValue] = useState([]);



  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setCategoryValue([]);
  };

  const handleSearch = () => {
    onFilter();
  };

  // No cancel button needed in flex form

  const handleCategoryChange = (selected) => {
    setCategoryValue(selected);
    const categoryIds = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, category_id: categoryIds },
    }));
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Queue Name</Form.Label>
              <Form.Control
                type="text"
                name="queue_name"
                placeholder={`Enter queue name`}
                className="input-field "
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">To</Form.Label>
              <Form.Control
                type="text"
                name="to"
                placeholder={`Type`}
                className="input-field "
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Calls From</Form.Label>
              <Form.Control
                type="text"
                name="calls_from"
                placeholder={`Calls From`}
                className="input-field "
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Period</Form.Label>
              <Select
                isMulti
                placeholder="Select"
                className="multi-select w-100"
                classNamePrefix="react-select"
                isSearchable
                name="period"
              />
            </Form.Group>
          </Col>
          <Col md={2} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100 mb-3"
            >
              <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
